exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".waiting-room-sidebar--2Q4Uzzm8FGWqF2Lf-pq9-e {\n  display: flex;\n  align-items: center;\n  font-size: .875rem;\n  line-height: 1.75rem;\n  color: #000;\n  margin-top: 1rem;\n}\n", ""]);

// exports
exports.locals = {
	"sidebarTitle": "waiting-room-sidebar--2Q4Uzzm8FGWqF2Lf-pq9-e",
	"sidebarTitle": "waiting-room-sidebar--2Q4Uzzm8FGWqF2Lf-pq9-e"
};